module.exports = __webpack_public_path__ + "static/media/06.6dc29950.jpg";